export default __webpack_public_path__ + "static/media/autodesk.8d1f1665.svg";